import { assignProps, removeItemByCode } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findRequestMarkdown } from './state';

const fetchRequestMarkdown = withDraft((draft, action) => {
  const item = findRequestMarkdown(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.markdowns[action.category].results.push({
      code: action.code,
      readErrors: [],
      readStatus: states.PENDING,
    });
  }
});

const fetchRequestMarkdownSuccess = withDraft((draft, action) => {
  const item = findRequestMarkdown(draft, action);
  assignProps(item, {
    ...action.result,
    readErrors: [],
    readStatus: states.SUCCESS,
  });
});

const fetchRequestMarkdownError = withDraft((draft, action) => {
  const item = findRequestMarkdown(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const closeRequestMarkdown = withDraft((draft, action) => {
  const item = findRequestMarkdown(draft, action);
  if (item) {
    draft.markdowns[action.category].results = removeItemByCode(draft.markdowns[action.category].results, item);
  }
});

export default {
  [actions.CLOSE_REQUEST_MARKDOWN]: closeRequestMarkdown,
  [actions.FETCH_REQUEST_MARKDOWN]: fetchRequestMarkdown,
  [actions.FETCH_REQUEST_MARKDOWN_ERROR]: fetchRequestMarkdownError,
  [actions.FETCH_REQUEST_MARKDOWN_SUCCESS]: fetchRequestMarkdownSuccess,
};
